var _circle, _circle2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "url(#paint0_linear_1486_2095)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3 27.9C27.03 27.31 26.3 26.7 26.3 25.75C26.3 24.66 27.31 23.9 29 23.9C30.42 23.9 31.13 24.44 31.39 25.3C31.51 25.7 31.84 26 32.26 26H32.56C33.22 26 33.69 25.35 33.46 24.73C33.04 23.55 32.06 22.57 30.5 22.19V21.5C30.5 20.67 29.83 20 29 20C28.17 20 27.5 20.67 27.5 21.5V22.16C25.56 22.58 24 23.84 24 25.77C24 28.08 25.91 29.23 28.7 29.9C31.2 30.5 31.7 31.38 31.7 32.31C31.7 33 31.21 34.1 29 34.1C27.35 34.1 26.5 33.51 26.17 32.67C26.02 32.28 25.68 32 25.27 32H24.99C24.32 32 23.85 32.68 24.1 33.3C24.67 34.69 26 35.51 27.5 35.83V36.5C27.5 37.33 28.17 38 29 38C29.83 38 30.5 37.33 30.5 36.5V35.85C32.45 35.48 34 34.35 34 32.3C34 29.46 31.57 28.49 29.3 27.9Z",
    fill: "url(#paint1_linear_1486_2095)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_2095",
    x1: 29,
    y1: 118.484,
    x2: 29,
    y2: -14.9677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF9C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#9D3CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1737E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1486_2095",
    x1: 29,
    y1: 56.7709,
    x2: 29,
    y2: 15.3548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF9C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#9D3CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1737E5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesOne);
export default __webpack_public_path__ + "static/media/featuresOne.7f9442892a288faa6293bbba640f4c55.svg";
export { ForwardRef as ReactComponent };